/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const hostname = window.location.hostname;
const region = hostname.includes('northeurope')
  ? 'northeurope'
  : hostname.includes('westeurope')
  ? 'westeurope'
  : null;

let redirectUri;
if (hostname.includes('synthetics.maersk.io')) {
  redirectUri = process.env.REACT_APP_REDIRECT_URI_AKAMAI;
} else if (region) {
  redirectUri =
    region === 'westeurope'
      ? process.env.REACT_APP_REDIRECT_URI_WESTEUROPE
      : process.env.REACT_APP_REDIRECT_URI_NORTHEUROPE;
} else {
  redirectUri = process.env.REACT_APP_REDIRECT_URI;
}

// MSAL Configuration
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d',
    redirectUri: redirectUri
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [`${process.env.REACT_APP_SCOPE}`]
};
